import knowledgeServiceApi from 'shared/api/knowledge.service.api';

export const getOriginalFileLink = async fileLink => {
  if (!fileLink) return null;
  try {
    console.log(fileLink?.split('.').pop()?.toLowerCase());
    const fileId = fileLink.split('/').pop().split('.').shift();
    const res = await knowledgeServiceApi.getOriginalFile(fileId);
    if (res.data?.url) return res.data;
  } catch (err) {
    console.error('Failed to fetch original file:', err);
  }
  return null;
};

export const handleDownloadOriginal = async fileLink => {
  const file = await getOriginalFileLink(fileLink);
  if (file?.url) {
    const a = document.createElement('a');
    a.href = file.url;
    a.setAttribute('download', '');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};
